import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Chat',
    component: () => import('../views/Chat3.vue')
  },
  {
    path: '/test',
    name: 'Chat',
    component: () => import('../components/test.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
